export { useMorphemeInfoPanelLearningProgressForgettingCurveSection } from "#morpheme-info-panel-learning-progress-forgetting-curve-section";
